<template>
    <CustomPage url="catalog" />
</template>

<script>
import CustomPage from '../_.vue'
import { GET_META } from '@@/graphQL/web'

export default {
  name: 'CatalogSlug',

  components: {
    CustomPage
  },

  layout: 'custom',

  data: () => ({
    metaBySlug: {
      title: '',
      description: '',
      alt: ''
    }
  }),

  apollo: {
    metaBySlug: {
      query: GET_META,
      variables () {
        return {
          siteCode: this.$store.state.siteCode,
          route: 'catalog',
          slug: this.$route.params.product_group_slug
        }
      }
    }
  },

  head () {
    return {
      title: this.metaBySlug?.title,
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.metaBySlug?.description
      }]
    }
  },

  beforeMount () {
    this.$store.commit('catalog/filters', [])
    this.$router.push({
      path: this.$route.path,
      params: { ...this.$route.params },
      query: {
        sort: this.$route.query.sort,
      }
    })
  }
}
</script>
